mutation UpdatePledge($pledgeId: ID!, $countersigned: Boolean!, $closerId: ID) {
  updatePledge(
    input: {
      pledgeId: $pledgeId
      countersigned: $countersigned
      closerId: $closerId
    }
  ) {
    pledge {
      id
      companyName
      currentPercentage
      dateSigned
      countersigned
      shareholdingPercentage
      valuation
    }
  }
}
